import Authorize from '@components/App/Authorize/Authorize'
import Theme from '@components/ArtBoard/Theme/Theme'
import type React from 'react'

// Figma OAuth callback screen (route /oauth/callback/figma).
export const Figma: React.FC = () => (
  <Theme>
    <Authorize />
  </Theme>
)
